module.exports = __webpack_public_path__ + "static/media/empty-seat.0ad8d81d.png";